import { useState } from "react";
import { Link } from "react-router-dom";
import { api, formatApiErrorDetail } from "../lib/api";
import { toast } from "sonner";
import { ArrowRight, Loader2, MailCheck } from "lucide-react";

export default function ForgotPassword() {
  const [email, setEmail] = useState("");
  const [submitting, setSubmitting] = useState(false);
  const [sent, setSent] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setSubmitting(true);
    try {
      await api.post("/auth/forgot-password", { email });
      setSent(true);
    } catch (err) {
      toast.error(formatApiErrorDetail(err.response?.data?.detail) || "Errore");
    } finally {
      setSubmitting(false);
    }
  };

  return (
    <div className="min-h-screen flex items-center justify-center bg-[#F7F8F9] p-6" data-testid="forgot-password-page">
      <div className="w-full max-w-md fade-up">
        <Link to="/login" className="inline-flex items-center gap-2 text-sm text-slate-500 hover:text-[#0F7B85]">
          ← Torna al login
        </Link>
        <div className="mt-6 bg-white border border-slate-200 rounded-2xl p-8 sm:p-10">
          {sent ? (
            <div className="text-center" data-testid="forgot-password-success">
              <div className="w-14 h-14 rounded-2xl bg-[#0F7B85]/10 flex items-center justify-center mx-auto">
                <MailCheck className="w-7 h-7 text-[#0F7B85]" />
              </div>
              <h1 className="font-display text-2xl text-[#0F7B85] mt-5">Controlla la tua email</h1>
              <p className="text-sm text-slate-600 mt-3 leading-relaxed">
                Se l&apos;indirizzo <strong>{email}</strong> è associato a un account Besafe Broker, riceverai
                a breve un&apos;email con il link per reimpostare la password.
              </p>
              <p className="text-xs text-slate-500 mt-4">
                Il link è valido per <strong>60 minuti</strong>. Non vedi l&apos;email? Controlla la cartella spam.
              </p>
              <Link
                to="/login"
                className="mt-6 inline-flex items-center justify-center gap-2 bg-[#0F7B85] text-white hover:bg-[#0A5C64] rounded-lg px-6 py-2.5 text-sm font-medium transition-colors"
              >
                Torna al login
              </Link>
            </div>
          ) : (
            <>
              <div className="flex items-center gap-4">
                <img src="/brand/besafe-logo.png" alt="Besafe Broker" style={{ height: "48px", width: "auto", maxWidth: "120px", objectFit: "contain" }} />
                <div className="border-l border-slate-200 pl-4">
                  <div className="text-xs uppercase tracking-[0.2em] text-slate-500">Password dimenticata</div>
                  <h1 className="font-display text-xl text-[#0F7B85] mt-0.5">Reimposta la password</h1>
                </div>
              </div>
              <p className="mt-5 text-sm text-slate-600 leading-relaxed">
                Inserisci l&apos;email del tuo account. Ti invieremo un link sicuro per impostare una nuova password.
              </p>
              <form onSubmit={submit} className="mt-6 space-y-4" data-testid="forgot-password-form">
                <div>
                  <label className="text-sm font-medium text-slate-700 mb-1.5 block">Email</label>
                  <input
                    type="email" required value={email} onChange={(e) => setEmail(e.target.value)}
                    data-testid="forgot-password-email-input"
                    placeholder="nome@email.it"
                    className="w-full bg-white border border-slate-200 rounded-lg px-4 py-3 focus:ring-2 focus:ring-[#0F7B85] focus:border-transparent outline-none transition-all"
                  />
                </div>
                <button
                  type="submit" disabled={submitting} data-testid="forgot-password-submit-button"
                  className="w-full bg-[#0F7B85] text-white hover:bg-[#0A5C64] disabled:opacity-60 rounded-lg px-6 py-3 font-medium transition-colors inline-flex items-center justify-center gap-2"
                >
                  {submitting ? <Loader2 className="w-4 h-4 animate-spin"/> : <ArrowRight className="w-4 h-4" />}
                  Invia link di reset
                </button>
              </form>
            </>
          )}
        </div>
      </div>
    </div>
  );
}
